import { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./PublicPlaygroundPage.scss";
import { useDispatch, useSelector } from "react-redux";
import backend from "../../../backend/backend";
import { useIntl } from "react-intl";
import McpPlaygroundActions from "../store/mcpPlaygroundActions";
import { mcpPlaygroundSelectors } from "../store/mcpPlaygroundReducer";
import Spinner from "../../../assets/icons/Spinner";
import { UnplugIcon } from "lucide-react";
import PlaygroundWidget from "../playground-widget/PlaygroundWidget";
import ThemeToggle from "../../../shared/theme/ThemeToggle";
import { useTheme } from "../../../shared/theme/ThemeContext";

const PublicPlaygroundPage = () => {
  const { playgroundId } = useParams();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { isDark } = useTheme();
  const playground = useSelector(mcpPlaygroundSelectors.getPublicPlayground);

  useEffect(() => {
    backend.getPublicPlayground(playgroundId).then((data) => {
      console.log("loaded public playground", data);
      dispatch({
        type: McpPlaygroundActions.PUBLIC_PLAYGROUND_LOADED,
        playground: data,
      });
    });
  }, [intl, dispatch]);

  return (
    <div className="public_playground_page">
      <ThemeToggle variant="floating" />
      {!playground && <Spinner />}
      {playground && (
        <div className="page_content">
          <div className="title_section">
            <div className="icon_container">
              <div className="icon_circle">
                <UnplugIcon size={24} color="#67748e" />
              </div>
            </div>
            <div className="title_column">
              <div className="title_value">{playground.name}</div>
              <div className="slug" title={playground.websiteUrl}>
                {playground.websiteUrl}
              </div>
            </div>
          </div>
          <div className="widget_container">
            <PlaygroundWidget
              playground={playground}
              uiMode={isDark ? "DARK" : "LIGHT"}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicPlaygroundPage;
